export const MockBackedByScienceData = {
  sectionTitle: 'Backed by Science',
  sectionSubtitle:
    'We’re science-led & always striving to ensure we’re up to speed with the latest cutting edge research.',
};
